import { defaultTelosProviderConfiguration } from 'src/features/on-chain/calculation-manager/providers/dexes/telos/default-constants';

export const APE_SWAP_TELOS_CONTRACT_ADDRESS = '0xb9667cf9a495a123b0c43b924f6c2244f42817be';

export const APE_SWAP_TELOS_PROVIDER_CONFIGURATION = defaultTelosProviderConfiguration;
